import { render, staticRenderFns } from "./WinbackSidebar.vue?vue&type=template&id=1e8cf1e8&scoped=true"
import script from "./WinbackSidebar.vue?vue&type=script&lang=js"
export * from "./WinbackSidebar.vue?vue&type=script&lang=js"
import style0 from "./WinbackSidebar.vue?vue&type=style&index=0&id=1e8cf1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8cf1e8",
  null
  
)

export default component.exports